<template>
  <div class="app-container">
    <nav class="global-nav">
      <div class="nav-container">
        <div class="nav-container__left">
          <label for="chkToggle" class="hamburger-icon" id="js-navbar-toggle">
            <i class="material-icons md-36">menu</i>
          </label>
          <input type="checkbox" id="chkToggle" :disabled="showAccountBox">
          <router-link class="nav-container__logo" :to="{ name: 'home' }" @click.native="closeNav">
            <img src="@/assets/images/logos/logo_no_text.svg" alt="Meagur Logo">
            Meagur
          </router-link>
          <ul class="nav-container__items" id="sideNav">
            <button class="exit-nav-button" @click="closeNav">
              Close
            </button>
            <li>
              <router-link class="nav-link" @click.native="closeNav" :to="{ name: 'current-pools' }">Current Pools</router-link>
            </li>
            <li>
              <router-link class="nav-link" @click.native="closeNav" :to="{ name: 'join-pool' }">Join a Pool</router-link>
            </li>
            <li>
              <router-link class="nav-link" @click.native="closeNav" :to="{ name: 'create-pool' }">Create a Pool</router-link>
            </li>
            <li>
              <router-link class="nav-link" @click.native="closeNav" :to="{ name: 'past-pools' }">Past Pools</router-link>
            </li>
            <li>
              <router-link class="about-link" @click.native="closeNav" :to="{ name: 'about' }">About Meagur</router-link>
            </li>
          </ul>
        </div>
        
        <div class="nav-container__right">

          <div class="account-link">
            <label for="chkAccount">
              <i class="material-icons account-link__icon">account_circle</i>
              <span class="account-link__text">Account</span>
            </label>
          </div>
          <router-link class="about-link" :to="{ name: 'about' }">About Meagur</router-link>
        </div>
      </div>
    </nav>

    <div class="app-container__restricted">
      <input type="checkbox" id="chkAccount" v-model="showAccountBox">
      <div class="account-popup">
        <i class="material-icons down-arrow md-48">arrow_drop_down</i>
        <div class="account-popup__logged-out" v-if="!authenticated">
          <button class="auth-button auth-button--primary" @click="showAuth">Please Login or Signup!</button>
        </div>
        <div class="account-popup__logged-in" v-else>
          <p class="name">Hi {{ user.name }}!</p>
          <ul>
            <li>
              <router-link @click.native="closeNav" :to="{ name: 'account' }" class="account-settings-link">Account Settings</router-link>
            </li>
            <li>
              <button class="logout" @click="callLogout">Logout</button>
            </li>
          </ul>
        </div>

      </div>
      <router-view v-if="showView"></router-view>

    </div>
      
    <!-- Signup/Login component -->
    <login-register v-if="showLoginRegister"></login-register>
    <!-- Verify Email component -->
    <verify-email v-if="getVerifyEmail.show"></verify-email>
    <!-- Set Password component -->
    <set-password v-if="getSetPassword.show"></set-password>
    <!-- Change Password component -->
    <change-password v-if="showChangePassword"></change-password>
    <http-in-progress v-if="httpInProgress"></http-in-progress>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import LoginRegister from '@/components/auth/LoginRegister'
  import HttpInProgress from '@/components/HttpInProgress'
  import VerifyEmail from '@/components/auth/VerifyEmail'
  import SetPassword from '@/components/auth/SetPassword'
  import ChangePassword from '@/components/auth/ChangePassword'

  export default {
    components: {
      'http-in-progress': HttpInProgress,
      'login-register': LoginRegister,
      'verify-email': VerifyEmail,
      'set-password': SetPassword,
      'change-password': ChangePassword
    },
    data() {
      return {
        showAccountBox: false
      }
    },
    computed: { 
      ...mapGetters([
        'httpInProgress',
        'authenticated',
        'user',
        'showLoginRegister',
        'getVerifyEmail',
        'getSetPassword',
        'showChangePassword'
      ]),
      showView() {
        if((this.showLoginRegister || this.getVerifyEmail.show || this.getSetPassword.show || this.showChangePassword || this.showAccountBox) && window.innerWidth < 769) {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      ...mapMutations([
        'HTTP_IN_PROGRESS',
        'HTTP_FINISHED',
        'SET_LOGIN_REGISTER'
      ]),
      ...mapActions([
        'logout'
      ]),
      closeNav() {
        this.showAccountBox = false
        document.getElementById('chkToggle').checked = false
        document.getElementById('chkAccount').checked = false
      },
      showAuth() {
        this.showAccountBox = false
        document.getElementById('chkAccount').checked = false
        this.SET_LOGIN_REGISTER(true)
      },
      callLogout() {
        this.HTTP_IN_PROGRESS()
        this.showAccountBox = false
        document.getElementById('chkAccount').checked = false
        this.logout().then(() => {
          this.HTTP_FINISHED()
        }).catch(() => {
          this.HTTP_FINISHED()
        })
      }
    }
  }
</script>

<style lang="scss">
  @import 'styles/app';
  @import 'styles/views/app';
</style>